<template>
  <div class="totalSales">
    <div class="top_box">
      <el-tooltip class="item" effect="light" content="总销售额为当日总销售额，非活动销售额" placement="right">
        <span class="title">总销售额 <i class="el-icon-question"></i></span>
      </el-tooltip>
      <el-radio-group v-model="timeType" @change="timeTypeChange">
        <el-radio-button v-for="item in timeOption" :key="item.code" :label="item.code">{{item.desc}}</el-radio-button>
      </el-radio-group>
    </div>
    <div id="totalSales_chart"></div>
    <div class="bottom_box">
      <img class="robot" src="../../../assets/image/workPlatform/robot.png" alt="">
      <div class="rightBox">
        <p class="msg" :title="resultData.businessAnalysis">经营分析：{{resultData.businessAnalysis}}</p>
        <div class="btn_box">
          <span class="btn" @click="sendReport" v-if="btnJurisdiction.isReport">去报名</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import echarts from 'echarts'
import { getTotalSales } from '@/api/businessAnalysis'

export default {
  props: {
    btnJurisdiction: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      gasId: '',
      timeType: 3,
      echartsDom: null,
      timeOption: [
        {
          code: 2,
          desc: '近7天'
        },
        {
          code: 3,
          desc: '近30天'
        }
      ],
      resultData: {}
    }
  },
  methods: {
    init (gasId) {
      this.gasId = gasId
      this.getTotalSales()
    },
    timeTypeChange () {
      this.$track.clickEvent('经营分析-时间组件', 1655798957)
      this.getTotalSales()
    },
    // 单位
    geUnit (num, unit) {
      let number = num || num === 0 ? (num >= 1000000 ? Math.round(num/100)/100 : num) : '-'
      let txt = unit || '元'
      return {
        num: number,
        unit: num >= 1000000 ? '万' + txt : txt
      }
    },
    drawLine () {
      this.echartsDom = null
      this.echartsDom = echarts.init(document.getElementById('totalSales_chart'))
      let data = this.resultData.seriesDto.map(item => {
        return {
          ...item,
          type: 'bar',
          barMaxWidth: '10',
        }
      })
      this.echartsDom.setOption({
        color: "#3377FF",
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#fff',
          axisPointer: {
            type: 'line',
            lineStyle: {
              type: 'dashed'
            },
            label: {
              backgroundColor: '#6a7985'
            }
          },
          formatter: (params) => {
            let relVal = ''
              for (var i = 0, l = params.length; i < l; i++) {
                relVal += params[i].axisValue + '<br/>' + params[i].marker + params[i].seriesName + '： ' + (this.geUnit(params[i].value).num) + this.geUnit(params[i].value).unit
              }
              return relVal
          },
          textStyle: {
            color: '#606266'
          },
          padding: [10,16],
          extraCssText: 'box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1)'
        },
        grid:{
          top:48,
          left:50,// 调整这个属性
          right:0,
          bottom:50
        },
        xAxis: {
          type: 'category',
          data: this.resultData.axis,
          nameTextStyle: {
            color:'#666'
          },
          axisLine: {
            lineStyle: {
              color:'#EAEAEA'
            }
          },
          axisLabel: {
            color:'#666'
          },
          axisTick: {
            show: false
          }
        },
        legend: {
          data: ['总销售额'],
          bottom: '0',
          itemHeight: 10,
          itemWidth: 10
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              type:'dashed',
              color:'#EAEAEA'
            }
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            formatter: '{value}元'
          }
        },
        series: data
      })
    },
    async getTotalSales () {
      try {
        const { code, result } = await getTotalSales({ gasId: this.gasId, businessType: this.timeType })
        if (code !== 200) return
        this.resultData = result
        this.drawLine()
      } catch (error) {
        console.log(error)
      }
    },
    sendReport () {
      this.$track.clickEvent('经营分析-去提报按钮', 1655798954)
      this.$router.push({path: '/promotion/centerShow'})
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../style/index.less');
/deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner{
  color: #409EFF;
  background-color: #fff;
  border-color: #409EFF;
  box-shadow: -1px 0 0 0 #409eff;
}
</style>